// Shared "page is actively scrolling" state, used to hide the side
// social-media bar while the visitor scrolls (the other floating buttons stay
// visible). One global `scroll` listener is shared across every consumer
// instead of each component attaching its own — the native `scroll` event
// fires the same way for touch-drag and mouse wheel/scrollbar, so no separate
// mobile/desktop handling is needed.

const SCROLL_IDLE_MS = 200;

const isScrolling = ref(false);
let listenerCount = 0;
let idleTimer = null;

function handleScroll() {
  isScrolling.value = true;
  clearTimeout(idleTimer);
  idleTimer = setTimeout(() => {
    isScrolling.value = false;
  }, SCROLL_IDLE_MS);
}

export function useScrollHide() {
  onMounted(() => {
    if (listenerCount === 0) {
      window.addEventListener('scroll', handleScroll, { passive: true });
    }
    listenerCount++;
  });

  onBeforeUnmount(() => {
    listenerCount--;
    if (listenerCount === 0) {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(idleTimer);
    }
  });

  return { isScrolling };
}
